import {getData, postData} from './http';

type IRegionalContext = TR.IRegionalContext;
type IRegion = TR.IRegion;
type IPointOfSale = TR.IPointOfSale;
type ILanguage = TR.ILanguage;
type IRegionalContextResponse = TR.IRegionalContextResponse;

const tenantUrl = 'website/tenants';
const pointOfSaleUrl = 'website/pointofsale';
const domainUrl = '/api2/globalisation/domains';
const countryUrl = '/api2/globalisation/countries';
const cultureCode = TRPCONFIG.Domain.CultureCode || 'en';
let regionalContext: IRegionalContext;

export function getRegions(tenantId: number, domainId: number) : Promise<IRegion[]> {
    if (regionalContext) {
        domainId = domainId === 0
            ? TRPCONFIG.Domain.DomainId
            : regionalContext.ParentDomainId;
    }

    const getUrl = `${tenantUrl}/${tenantId}/domains/${domainId}/culture/${cultureCode}`;

    return getData(getUrl, { logErrors: false, cache: true });
}

export interface ILegacyDomain{
    Id: number;
}

export async function getAllDomains() {
    const data = await getData(domainUrl, { logErrors: false }) as ILegacyDomain[];
    const turnedOffDomains = TRPCONFIG.Domain2.ADv1BlockedDomains;
    return Promise.resolve(data.filter(d => turnedOffDomains.indexOf(d.Id) === -1));
}

export function getStates(countryCode: string) {
    const getUrl = `${countryUrl}/${countryCode}/states`;
    return getData(getUrl, { logErrors: false });
}

export function getCountries() {
    const getUrl = `${countryUrl}?cultureCode=${cultureCode}`;
    return getData(getUrl, { logErrors: false });
}

function regionContainingPos(regions: IRegion[], posId: number): IRegion {
    return regions[_.findIndex(regions, r =>
        null != _.find(r.PointsOfSale, p => p && p.Id === posId)
    )];
}

function findPosInRegion(region: IRegion, posId: number): IPointOfSale {
    return region.PointsOfSale[_.findIndex(region.PointsOfSale, p => p.Id === posId)];
}

function findLanguageInPos(pos: IPointOfSale, cultureCode: string): ILanguage | null {
    if (pos == null) {
        return null;
    }
    const lang = pos.Context.Languages[_.findIndex(pos.Context.Languages, l => l.Code === cultureCode)];
    return lang ? lang : pos.Context.Languages[0];
}

export function getSelectedRegionalContext(): Promise<IRegionalContext> {
    if (regionalContext != null) {
        return Promise.resolve(regionalContext);
    }

    const regContext = TRPCONFIG.SelectedRegionalContext;
    const tenantId = TRPCONFIG.Domain.TenantId;
    const domainId = regContext == null || regContext.ParentDomainId === 0
        ? TRPCONFIG.Domain.DomainId
        : regContext.ParentDomainId;

    return getRegions(tenantId, domainId).then(regions => {
        const region = regionContainingPos(regions, regContext.PointOfSaleId);
        const pos = findPosInRegion(region, regContext.PointOfSaleId);
        const lang = findLanguageInPos(pos, regContext.CultureCode);
        regionalContext = {
            PointOfSale: pos,
            Language: lang,
            Region: region,
            Inferred: false,
            ParentDomainId: regContext.ParentDomainId,
            TenantId: tenantId
        };
        return regionalContext;
    });
}

export function setRegionalContext(request: TR.IRegionalContextRequest): Promise<IRegionalContextResponse> {
    return postData<IRegionalContextResponse>(`${pointOfSaleUrl}/setregionalcontext`, request).then(data => {
        if (data.Success) {
            if (data.Redirecturl) {
                window.location.href = window.location.protocol === 'https:'
                                        ? data.Redirecturl.replace('http://', 'https://')
                                        : data.Redirecturl;
            } else {
                window.location.reload();
            }
        }
        return data;
    });
}
